var map = {
	"./ADA.jpg": 143,
	"./BTC.jpg": 144,
	"./DOGE.jpg": 145,
	"./DOT.jpg": 146,
	"./ETC.jpg": 147,
	"./ETH.jpg": 148,
	"./SOL.jpg": 149,
	"./TRX.jpg": 150,
	"./USDT (ERC20).jpg": 151,
	"./USDT (TRC20).jpg": 152,
	"./XRP.jpg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;